import React from 'react'
import FaqList from '../FaqList'
import { cmsUseNew } from '../../utils/cms'
import FaqSection from '../FaqSection'

const faqs = [
  {
    question: "WHAT IS A 'MY OFFER'?",
    answer: (
      <>
        A 'My Offer' is a special discount available in your Hump Club account. These could be:
        <ul>
          <li>Discounts on selected products</li>
          <li>Birthday rewards</li>
          <li>Loyalty rewards</li>
          <li>Personalised rewards</li>
          <li>Anniversary rewards</li>
        </ul>
        Each offer is single-use and valid for a limited time, so don't miss out!
      </>
    ),
  },
  {
    question: "HOW DO I REDEEM A 'MY OFFER'?",
    answer: (
      <>
        <strong>In store:</strong> At loyalty participating venues, just quote your mobile number at
        checkout.
        <br />
        <br />
        <strong>Online:</strong> Redeem 'My Offers' through Click & Collect or Delivery at
        participating stores.
      </>
    ),
  },
  {
    question: 'HOW DO I EARN LOYALTY REWARDS?',
    answer: (
      <>
        Earning rewards is easy, just shop at participating Thirsty Camel bottleshops through your
        Hump Club account!
        <br />
        <br />
        <strong>In-store:</strong> Simply quote your mobile number at checkout.
        <br />
        <strong>Online:</strong> Log into your Hump Club account when purchasing via Click & Collect
        or Delivery
        <br />
        <br />
        The more you shop, the more you unlock! Every dollar spent through your Hump Club account
        keeps you eligible for exclusive perks, including:
        <ul>
          <li>Weekly discount offers</li>
          <li>Bonus drinks & prizes</li>
          <li>Birthday rewards</li>
          <li>Exclusive games</li>
          <li>Personalised offers</li>
        </ul>
        Start earning today and make every sip more rewarding!
      </>
    ),
  },
  {
    question: "WHAT'S MY BIRTHDAY REWARD?",
    answer: (
      <>
        As a Hump Club member, your birthday comes with a little extra fun! We'll send you an email
        with a Spin the Wheel game, giving you the chance to win a voucher worth $5, $10, $20, or
        even $50!
        <br />
        <br />
        Your reward is valid for 14 days and can be redeemed in-store or online.
      </>
    ),
  },
  {
    question: "WHERE CAN I FIND MY AVAILABLE 'MY OFFERS'?",
    answer: (
      <>
        Log into your Hump Club account anytime to check your available offers. Plus, keep an eye on
        your inbox, we'll send you a weekly email with the latest deals, exclusive competitions, and
        your Loyalty Rewards!
      </>
    ),
  },
  {
    question: 'CAN I REDEEM MY OFFERS ONLINE?',
    answer: <>Yes! But only via Click & Collect and Delivery at participating stores.</>,
  },
  {
    question: 'CAN I EARN REWARDS ONLINE?',
    answer: (
      <>
        Absolutely! Any online purchases made through www.thirstycamel.com.au are eligible for Hump
        Club Rewards. Whether you're shopping via Click & Collect or Delivery, you'll keep unlocking
        great Hump Club perks!
      </>
    ),
  },
  {
    question: 'ARE *UNLIMITED MY OFFERS REALLY UNLIMITED?',
    answer: (
      <>
        Our "Unlimited Offers" give you access to extra-good deals for a limited time, but like all
        great things, there are a few conditions. Each offer has a maximum redemption limit of 50
        per customer and is only available at selected participating stores.
      </>
    ),
  },
]

export default function HumpClubLandingFaq() {
  if (!cmsUseNew()) {
    return <FaqList faqs={faqs} />
  }

  return <FaqSection keyName="hump-club-landing" fallbackFaqs={faqs} />
}
